import { PropsWithChildren } from 'react'

import classNames from 'classnames'
import { Box, Button, Typography } from 'components'

import { CardProps, sizeVariants } from './types'

export const Card = ({
  title,
  className,
  titleClassName,
  bodyClassName,
  hasShowMore,
  size = 'md',
  stretch,
  children,
  onShowMore,
}: PropsWithChildren<CardProps>) => {
  return (
    <Box
      className={classNames(
        'rounded-2xl bg-light-card dark:bg-dark-card',
        stretch ? 'flex flex-1' : 'inline-flex',
        sizeVariants[size],
        className,
      )}
      col
    >
      {title && (
        <Typography className={classNames('my-4', titleClassName)} variant="h5">
          {title}
        </Typography>
      )}
      {children && (
        <div className={classNames('my-4 w-full', bodyClassName)}>
          {children}
        </div>
      )}
      {hasShowMore ? (
        <Button textColor="primaryBtn" type="borderless" onClick={onShowMore}>
          Show more
        </Button>
      ) : null}
    </Box>
  )
}
